export default "__VITE_ASSET__c814665b__"